var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import ScheduleForm from "../../../Presentational/Message/ScheduleForm";
import EmailOrSMSForm, { EMAIL_OR_SMS_DEFAULTS, } from "../../../Presentational/Message/EmailOrSMSForm";
import DateService from "../../../../Services/Shared/Date.service";
export const MESSAGE_SCHEDULE_FORM_DEFAULTS = Object.assign(Object.assign({}, EMAIL_OR_SMS_DEFAULTS), { isRecurring: "true", rbTagsAnyAll: "any", 
    // @ts-expect-error - TS2322 - Type '{ isRecurring: string; rbTagsAnyAll: string; sendToInstitutional: true; isEmail?: "true" | undefined; template?: PersonMessageTemplate | null | undefined; ... 6 more ...; logMessage?: boolean | undefined; } | { ...; }' is not assignable to type 'Partial<MessageScheduleFormState>'.
    sendToInstitutional: true });
export const messageScheduleToFormState = ({ messageSchedule, caseloadPeople, }) => {
    var _a, _b, _c;
    // @ts-expect-error - TS2322 - Type '{}' is not assignable to type 'MessageScheduleFormState'.
    const formState = {};
    formState.id = messageSchedule.scheduledMessage.id;
    formState.scheduleName = messageSchedule.scheduledMessage.name;
    formState.active = messageSchedule.scheduledMessage.active;
    if (
    // @ts-expect-error Not sure how to fix this one, union of TS types
    messageSchedule.automatedSchedule.interval === 0 ||
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'number' and 'string' have no overlap.
        messageSchedule.automatedSchedule.interval === "0") {
        formState.isRecurring = "false";
        // @ts-expect-error Not sure how to fix this one, union of TS types
        const minutes = messageSchedule.automatedSchedule.minutes;
        // @ts-expect-error Not sure how to fix this one, union of TS types
        let hours = messageSchedule.automatedSchedule.hours;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string' and 'number' have no overlap.
        if (messageSchedule.automatedSchedule.meridiem === 1) {
            hours += 12;
        }
        formState.runEveryDays = 0;
        // @ts-expect-error - TS2740 - Type 'Moment' is missing the following properties from type 'Date': toDateString, toTimeString, toLocaleDateString, toLocaleTimeString, and 35 more.
        formState.sendDate = moment(messageSchedule.scheduledMessage.nextExecutionDate);
        formState.sendDateTime = new Date(messageSchedule.scheduledMessage.nextExecutionDate);
    }
    else {
        formState.isRecurring = "true";
        // @ts-expect-error Not sure how to fix this one, union of TS types
        formState.runEveryDays = messageSchedule.automatedSchedule.interval;
        // @ts-expect-error - TS2322 - Type 'Moment' is not assignable to type 'Date'.
        formState.executionDate = moment(messageSchedule.scheduledMessage.nextExecutionDate);
        formState.runEveryDayTime = new Date(messageSchedule.scheduledMessage.nextExecutionDate);
    }
    // @ts-expect-error - TS2322 - Type 'boolean' is not assignable to type '"true" | "false"'. | TS2339 - Property 'scheduledMessage' does not exist on type 'MessageSchedule'.
    formState.isEmail = !messageSchedule.scheduledMessage.isSms;
    if (formState.isEmail !== "false") {
        // @ts-expect-error Not sure how to fix this one, union of TS types
        formState.sendToInstitutional =
            messageSchedule.scheduledMessage.sendToInstitutionalEmail;
    }
    if (formState.isEmail !== "false") {
        // @ts-expect-error Not sure how to fix this one, union of TS types
        formState.sendToPersonal =
            messageSchedule.scheduledMessage.sendToPersonalEmail;
    }
    // @ts-expect-error Not sure how to fix this one, union of TS types
    formState.noteFromMessage =
        messageSchedule.scheduledMessage.createNoteFromMessage;
    if (formState.noteFromMessage) {
        formState.selectedNoteTypes = [
            // @ts-expect-error - TS2339 - Property 'scheduledMessage' does not exist on type 'MessageSchedule'.
            ...messageSchedule.scheduledMessage.noteTypes,
        ];
    }
    if (formState.isEmail !== "false") {
        formState.subject = messageSchedule.messageTemplate.subject;
    }
    if (formState.isEmail !== "false") {
        formState.body = messageSchedule.messageTemplate.body;
    }
    if (formState.isEmail !== "true") {
        formState.smsBody = messageSchedule.messageTemplate.body;
    }
    formState.to = {
        label: (_a = messageSchedule.scheduledMessage.population) === null || _a === void 0 ? void 0 : _a.name,
        value: (_b = messageSchedule.scheduledMessage.population) === null || _b === void 0 ? void 0 : _b.id,
        isPopulation: true,
        // @ts-expect-error Not sure how to fix it
        pop: messageSchedule.scheduledMessage.population,
    };
    if ((_c = messageSchedule.scheduledMessage.population) === null || _c === void 0 ? void 0 : _c.adHoc) {
        formState.populationAdHocCaseloads = caseloadPeople;
    }
    // @ts-expect-error - TS2339 - Property 'scheduledMessage' does not exist on type 'MessageSchedule'.
    formState.fromEmailAddress = messageSchedule.scheduledMessage.sender;
    formState.logMessage = messageSchedule.scheduledMessage.logged;
    return formState;
};
export const messageScheduleFormStateToRequest = (formState) => {
    let request = null;
    const dateTime = formState.isRecurring === "true"
        ? DateService.getDateWithTime(
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'toDate' does not exist on type 'Date'.
        formState === null || formState === void 0 ? void 0 : formState.executionDate.toDate(), formState === null || formState === void 0 ? void 0 : formState.runEveryDayTime)
        : DateService.getDateWithTime(
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'toDate' does not exist on type 'Date'.
        formState === null || formState === void 0 ? void 0 : formState.sendDate.toDate(), formState === null || formState === void 0 ? void 0 : formState.sendDateTime);
    let hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    let meridiem = 0;
    if (hours > 12) {
        hours -= 12;
        if (hours === 12) {
            hours = 0;
        }
        meridiem = 1;
    }
    else if (hours === 24) {
        hours = 0;
        meridiem = 1;
    }
    request = {
        id: formState.id || null,
        name: formState.scheduleName,
        active: formState.isRecurring !== "true" ? true : formState.active,
        isDelayedMessage: formState.isRecurring !== "true",
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
        nextExecutionDate: formState.isRecurring === "true"
            ? // @ts-expect-error - TS2345 - Argument of type 'Date | null | undefined' is not assignable to parameter of type 'Date'.
                DateService.display(formState.executionDate.toDate())
            : // @ts-expect-error - TS2345 - Argument of type 'Date | null | undefined' is not assignable to parameter of type 'Date'.
                DateService.display(formState.sendDate.toDate()),
        automatedSchedule: {
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'string'.
            hours,
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            interval: parseInt(formState.runEveryDays, 10) || 0,
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'string'.
            meridiem,
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'string'.
            minutes,
        },
    };
    // @ts-expect-error - TS2322 - Type 'MessageSchedule | null | undefined' is not assignable to type 'MessageSchedule'.
    return request;
};
const MessageScheduleForm = (_a) => {
    var { isEmail, renderAttachments } = _a, formProps = __rest(_a, ["isEmail", "renderAttachments"]);
    return (_jsxs(_Fragment, { children: [_jsx(ScheduleForm, Object.assign({}, formProps)), _jsx(EmailOrSMSForm, Object.assign({ showRecipientForm: true }, formProps, { showOnlyFilters: true, defaultTab: isEmail ? 0 : 1, renderAttachments: renderAttachments || null, hideInlineAttachmentsCheckbox: true })), _jsx("input", { type: "hidden", name: "id", ref: formProps.register })] }));
};
export default MessageScheduleForm;
